<template>
  <div class="page-container">
    <div class="doc-wrapper">
      <h1 class="main-title">{{ txt.title }}</h1>
      <div class="meta-info">VERSION 2.0 | JAN 2026</div>

      <section class="doc-section">
        <h2>1. {{ txt.vision.title }}</h2>
        <p>{{ txt.vision.p1 }}</p>
        <p>{{ txt.vision.p2 }}</p>
      </section>

      <section class="doc-section">
        <h2>2. {{ txt.market.title }}</h2>
        <p>{{ txt.market.p1 }}</p>
        <p>{{ txt.market.p2 }}</p>
      </section>

      <section class="doc-section">
        <h2>3. {{ txt.compliance.title }}</h2>
        <p>{{ txt.compliance.p1 }}</p>
        <p>{{ txt.compliance.p2 }}</p>
      </section>

      <section class="doc-section">
        <h2>4. {{ txt.culture.title }}</h2>
        <p>{{ txt.culture.p1 }}</p>
      </section>
    </div>
  </div>
</template>

<script>
import DICT from '../locales/data.js';

export default {
  props: ['lang'],
  computed: { txt() { return DICT[this.lang].whitepaper || DICT['en'].whitepaper } }
}
</script>

<style scoped>
/* 复用样式 */
.page-container { padding: 40px 0 100px; background: #000; min-height: 100vh; color: #ccc; }
.doc-wrapper { max-width: 900px; margin: 0 auto; padding: 40px; background: #0a0b10; border: 1px solid #222; border-radius: 8px; }
.main-title { color: #fff; font-size: 32px; font-weight: 800; margin-bottom: 10px; border-bottom: 1px solid #333; padding-bottom: 20px; }
.meta-info { font-size: 11px; color: #555; margin-bottom: 40px; font-family: monospace; letter-spacing: 1px; }
.doc-section { margin-bottom: 50px; }
h2 { color: #fff; font-size: 20px; border-left: 3px solid #3761F9; /* Whitepaper 用蓝色 */ padding-left: 15px; margin-bottom: 20px; }
p { font-size: 14px; line-height: 1.8; margin-bottom: 15px; color: #aaa; text-align: justify; }
@media(max-width: 768px) { .doc-wrapper { padding: 20px; border: none; } }
</style>